// extracted by mini-css-extract-plugin
module.exports = {"details":"ingredient-details_details__2-ZMQ","nutrition":"ingredient-details_nutrition__z2FU4","item":"ingredient-details_item__fYd_w"};